import { Container } from "../../UI/container/Container";
import { MyH1 } from "../../UI/my-h1/MyH1";
import { useColors } from "../../../hooks/colors/useColors";
import { PageHeader } from "../page-header/PageHeader";
import { IconCalendarEvent } from "@tabler/icons";
import { useTranslation } from "next-i18next";
import { ContentVisualizer } from "../content-visualizer/ContentVisualizer";
import { ButtonLink } from "../../UI/button-link/ButtonLink";
import { isMobile } from "react-device-detect";
import { Fragment } from "react";
import { Card } from "@mantine/core";
import { mobile, tablet } from "../../../constants/env";
import { Footer } from "../homepage/footer/Footer";
import { UsefulArticleData } from "../../../hooks/react-query/useUsefulArticlesList";
import Image from "next/image";

type Props = {
  article: UsefulArticleData;
};

export function UsefulArticlePage({ article }: Props) {
  const { colors } = useColors();
  const { i18n } = useTranslation("common");

  let imageClass = "p-0 flex relative w-[320px] h-[180px]";
  if (!mobile) imageClass = "p-0 flex relative w-[1152px] h-[648px]";
  if (tablet) imageClass = "p-0 flex relative w-[480px] h-[270px]";

  return (
    <Fragment>
      <PageHeader>
        <MyH1
          size={isMobile ? "1.8rem" : "2.6rem"}
          className="text-center"
          color="white"
        >
          {article.title}
        </MyH1>
      </PageHeader>
      <Container noHeight>
        {article.image && article.image.length > 10 && (
          <div
            className="flex justify-center"
            style={{ marginTop: -50, marginBottom: 50 }}
          >
            <Card className={imageClass} radius="xs" shadow="md">
              <Image
                priority
                alt="Person"
                src={article.image}
                sizes="1152px 480px 320px"
                fill
                style={{
                  objectFit: "cover",
                }}
              />
            </Card>
          </div>
        )}
        <ContentVisualizer content={article.content} />
        <div className="flex justify-center my-10">
          <ButtonLink
            className="w-[300px] h-[50px]"
            href="/agendar"
            uppercase
            color={colors.secondary}
            title={i18n.t("book-app")}
            icon={<IconCalendarEvent color={colors.white} />}
            rounded
          />
        </div>
        {/*{authorSlug && (*/}
        {/*  <div>*/}
        {/*    {blogs && (*/}
        {/*      <Grid>*/}
        {/*        <Grid.Col span={12}>*/}
        {/*          <h2*/}
        {/*            style={{ color: colors.primary }}*/}
        {/*            className="text-center mt-6 text-4xl"*/}
        {/*          >*/}
        {/*            {i18n.t("blog.some-entries")}*/}
        {/*          </h2>*/}
        {/*        </Grid.Col>*/}
        {/*        {blogs.map((post, index) => {*/}
        {/*          return <BlogCard key={index} data={post} />;*/}
        {/*        })}*/}
        {/*      </Grid>*/}
        {/*    )}*/}
        {/*    <div className="flex justify-center w-full">*/}
        {/*      <Link*/}
        {/*        href={`/blog/autor/${authorSlug}`}*/}
        {/*        className="hover:cursor-pointer text-center"*/}
        {/*      >*/}
        {/*        <div className="text-center p-4">*/}
        {/*          <div*/}
        {/*            style={{ color: colors.secondary }}*/}
        {/*            className="text-center font-bold text-2xl p-2 hover flex items-center"*/}
        {/*          >*/}
        {/*            <span>{i18n.t("blog.all-entries")}</span>*/}
        {/*            <IconArrowNarrowRight*/}
        {/*              size="2rem"*/}
        {/*              color={colors.secondary}*/}
        {/*            />*/}
        {/*          </div>*/}
        {/*        </div>*/}
        {/*      </Link>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*)}*/}
      </Container>
      <Footer isVisible delay />
    </Fragment>
  );
}
